import React from 'react';

function AreaValveBox() {
  return (
    <>
      <style>{`
        .avb-wrapper {
          padding: 2rem;
          background-color: #f5f8fa;
          font-family: 'Segoe UI', sans-serif;
        }

        .avb-content {
          max-width: 850px;
          margin: auto;
          background-color: #fff;
          padding: 2rem;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .avb-content h1 {
          font-size: 2.4rem;
          text-align: center;
          color: #2c3e50;
          margin-bottom: 1.5rem;
        }

        .avb-content img {
          display: block;
          max-width: 100%;
          height: auto;
          margin: 0 auto 1.5rem auto;
          border-radius: 10px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          clip-path: inset(0 0 0 2px);
        }

        .avb-content p {
          font-size: 1.1rem;
          line-height: 1.6;
          color: #444;
        }

        @media (max-width: 768px) {
          .avb-content h1 {
            font-size: 2rem;
          }

          .avb-wrapper {
            padding: 1rem;
          }

          .avb-content {
            padding: 1.2rem;
          }
        }
      `}</style>

      <main className="avb-wrapper">
        <section className="avb-content">
          <h1>Area Valve Box</h1>
          <img src="avb.png" alt="Area Valve Box" />
          <p>
            We bring for our clients our area valve box that are based on latest technology.
            The area valve box comes with a proper locking lid having closure.
            The lid is also surrounded with an external seal.
            The area valve boxes available with us are being largely used by global clients.
          </p>
        </section>
      </main>
    </>
  );
}

export default AreaValveBox;
